import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface DockDoorSearchBarProps {
  searchText: string;
  onSearchChange: (text: string) => void;
}

export function DockDoorSearchBar({ searchText, onSearchChange }: DockDoorSearchBarProps) {
  const { t } = useTranslation();
  const [localQuery, setLocalQuery] = useState(searchText);

  // Debounce search input — Xamarin fires SearchCommand on every TextChanged
  useEffect(() => {
    const timer = setTimeout(() => {
      onSearchChange(localQuery);
    }, 300);
    return () => {
      clearTimeout(timer);
    };
  }, [localQuery, onSearchChange]);

  // Sync external search text changes
  useEffect(() => {
    setLocalQuery(searchText);
  }, [searchText]);

  return (
    // Margin: Xamarin {OnIdiom Default='0,5,-10,0', Phone=0}
    <div className="mx-0 md:mx-0 md:mt-[5px]">
      {/* Frame: CornerRadius=3, BorderColor=SearchBarBorderColor, bg=White */}
      <div className="h-10 md:h-[35px] rounded-[3px] border border-[#D2E3F0] bg-white mx-[10px]">
        <input
          type="text"
          placeholder={t('common.search')}
          value={localQuery}
          maxLength={100}
          onChange={(e) => {
            setLocalQuery(e.target.value);
          }}
          // FontFamily=PoppinsRegular, FontSize=12, Margin="10,0,0,0"
          className="h-full w-full bg-transparent pl-[10px] pr-3 text-xs font-poppins text-[#3B3B3B] placeholder:text-[#A0AEC0] outline-none"
        />
      </div>
    </div>
  );
}
